import { assign, createMachine, InterpreterFrom, StateConfig, StateFrom } from 'xstate'

import { setAnalyticsEvent } from '../../analytics/state'

export type OnboardPatientContext = {
  // save index for rendering selected dispensary with previous background graphic
  dispensaryIndex?: number
  hasPractitioner?: boolean
}
export type OnboardPatientEvent =
  | { type: 'CHOOSE_DISPENSARY'; dispensaryIndex?: number; dispensarySlug: string }
  | { type: 'RESTORE' }
export type OnboardPatientState = {
  value: 'initial' | 'chooseDispensary' | 'invalid' | 'complete'
  context: OnboardPatientContext
}

export type OnboardPatientMachine = typeof machine
export type OnboardPatientInterpreter = InterpreterFrom<typeof machine>
export type OnboardPatientObserverCallback = (state: StateFrom<typeof machine>) => void
export type OnboardPatientStateConfig = StateConfig<OnboardPatientContext, OnboardPatientEvent>
export type OnboardPatientStateObject = StateFrom<typeof machine>
export type OnboardPatientStateValue = OnboardPatientState['value']

export const machine = createMachine<
  OnboardPatientContext,
  OnboardPatientEvent,
  OnboardPatientState
>(
  {
    predictableActionArguments: true,
    id: 'onboard_patient',
    initial: 'initial',
    context: {
      dispensaryIndex: undefined,
      hasPractitioner: undefined,
    },
    states: {
      initial: {
        on: {
          '*': {
            target: 'chooseDispensary',
            actions: ['pushStartPatientOnboardingAnalyticsEvent'],
          },
        },
      },
      chooseDispensary: {
        on: {
          CHOOSE_DISPENSARY: {
            target: 'complete',
            actions: [
              assign({
                dispensaryIndex: (_context, event) => event.dispensaryIndex,
              }),
              'pushSelectDispensaryAnalyticsEvent',
            ],
          },
        },
      },
      invalid: {
        on: {
          RESTORE: 'complete',
        },
      },
      complete: {
        type: 'final',
      },
    },
  },
  {
    actions: {
      pushStartPatientOnboardingAnalyticsEvent: () => {
        setAnalyticsEvent({
          event: 'start_patient_onboarding',
        })
      },
      pushSelectDispensaryAnalyticsEvent: (_context, event) => {
        if (event.type !== 'CHOOSE_DISPENSARY') {
          return
        }
        setAnalyticsEvent({
          event: 'select_dispensary',
          dispensarySlug: event.dispensarySlug,
        })
      },
    },
  },
)
